module.exports = __webpack_public_path__ + "img/star.4d33f476.svg";